export default __webpack_public_path__ + "static/media/img_438.a4db680e.jpg";